import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";

// If Alpine isn’t present or hasn’t started, start it
if (
  window.Alpine &&
  typeof window.Alpine.start === "function" &&
  !window.Alpine.isStarted
) {
  window.Alpine.start();
  window.Alpine.isStarted = true;
}

window.initMasonry = function () {
  const grid = document.querySelector(".grid-onJob");
  if (!grid) return;

  imagesLoaded(grid, () => {
    const msnry = new Masonry(grid, {
      itemSelector: ".grid-item",
      columnWidth: ".grid-sizer",
      percentPosition: true,
      transitionDuration: "0.35s",
    });
    imagesLoaded(grid).on("progress", () => msnry.layout());

    msnry.on("layoutComplete", (laidOut) => {
      laidOut.forEach((item) => item.element.classList.add("is-positioned"));
    });

    window.addEventListener("resize", () => msnry.layout());
  });
};

document.addEventListener("alpine:init", () => {
  Alpine.data("masonryGrid", () => ({
    visibleCount: 5,
    get hasMore() {
      return this.visibleCount < document.querySelectorAll(".grid-item").length;
    },
    showMore() {
      this.visibleCount += 5;
      const totalItems = document.querySelectorAll(".grid-item").length;
      if (this.visibleCount > totalItems) {
        this.visibleCount = totalItems;
      }

      this.$nextTick(() => {
        const grid = document.querySelector(".grid-onJob");
        if (!grid) return;
        imagesLoaded(grid, () => {
          window.initMasonry();
        });
      });
    },
    initMasonry() {
      this.$nextTick(() => {
        window.initMasonry();
      });
    },
  }));
});
